import { SideNavInterface } from "../../interfaces/side-nav.type";

export const ROUTES: SideNavInterface[] = [
    {
        path: 'apps/public-apps', // -public apps- en haut du menu, admin seulement
        title: 'menu.publicApps',
        iconType: 'nzIcon',
        iconTheme: 'outline',
        icon: 'global',
        submenu: [],
        role: 'ADMIN'
    },
    {
        path: '/dashboard/default',
        title: 'menu.home',
        iconType: 'nzIcon',
        iconTheme: 'outline',
        icon: 'home',
        submenu: [],
        role: 'ADMIN'   // Accueil reserve a l'admin (masque pour tous les autres)
    },
    {
        path: 'apps/projects/project-list',
       title: 'menu.appsAdmin', // par défaut pour ADMIN
      titleForNonAdmin: 'menu.myApps',
        iconType: 'nzIcon',
        iconTheme: 'outline',
        icon: 'appstore',
        submenu: []
    }, {
        path: 'apps/profile',
        title: 'menu.profile',
        iconType: 'nzIcon',
        iconTheme: 'outline',
        icon: 'user',
        submenu: []
    },
  
    {
        path: 'apps/chat',
        title: 'menu.chat',
        iconType: 'nzIcon',
        iconTheme: 'outline',
        icon: 'message',
        submenu: []
    },
    


    // -hidden pages- menu Permission (Permission, Scope, Ressource, Policy) masque ; routes commentees dans apps-routing.module.ts
    /* {
        title: 'menu.permission',
        iconType: 'nzIcon',
        iconTheme: 'outline',
        icon: 'check-circle',
        submenu: [
           {
        path: 'apps/permission',
        title: 'menu.permission',
        iconType: 'nzIcon',
        iconTheme: 'outline',
        icon: 'check-circle',
        submenu: [], 
        role: 'ADMIN'
    },   {
        path: 'apps/scope',
        title: 'menu.scope',
        iconType: 'nzIcon',
        iconTheme: 'outline',
        icon: 'check-circle',
        submenu: [], 
        role: 'ADMIN'
    },   {
        path: 'apps/ressource',
        title: 'menu.resource',
        iconType: 'nzIcon',
        iconTheme: 'outline',
        icon: 'check-circle',
        submenu: [], 
        role: 'ADMIN'
    },   {
        path: 'apps/policy',
        title: 'menu.policy',
        iconType: 'nzIcon',
        iconTheme: 'outline',
        icon: 'check-circle',
        submenu: [], 
        role: 'ADMIN'
    }
        ],
        role: 'ADMIN'
    }, */
      {
        title: 'menu.connection',
        iconType: 'nzIcon',
        iconTheme: 'outline',
        icon: 'google',
        submenu: [
       {
        path: 'apps/champsEtablisment',
        title: 'menu.fieldEtab',
        iconType: 'nzIcon',
        iconTheme: 'outline',
        icon: 'form',
        submenu: [], 
        role: 'ADMIN'
    },
       // -hidden pages- Champ Role Client masque du menu (la route reste dans apps-routing.module.ts)
       /* {
        path: 'apps/champsRoleClient',
        title: 'menu.fieldRoleClient',
        iconType: 'nzIcon',
        iconTheme: 'outline',
        icon: 'form',
        submenu: [],
        role: 'ADMIN'
    }, */ {
        path: 'apps/champsRole',
        title: 'menu.fieldRole',
        iconType: 'nzIcon',
        iconTheme: 'outline',
        icon: 'form',
        submenu: [], 
        role: 'ADMIN'
    },
        ], 
        role: 'ADMIN'
    },
        { 
        title: 'menu.roles',
        iconType: 'nzIcon',
        iconTheme: 'outline',
        icon: 'usergroup-add',
        submenu: [
            // -hidden pages- Roles Clients masque ; route commentee dans apps-routing.module.ts
            /* {
        path: 'apps/role-client',
        title: 'menu.rolesClient',
        iconType: 'nzIcon',
        iconTheme: 'outline',
        icon: 'usergroup-add',
        submenu: [],
        role: 'ADMIN'
    }, */
    {
        path: 'apps/role',
        title: 'menu.rolesSocle',
        iconType: 'nzIcon',
        iconTheme: 'outline',
        icon: 'usergroup-add',
        submenu: [], 
        role: 'ADMIN'
    },
    
        ], 
        role: 'ADMIN'
    },
    {
        path: 'apps/user-client',
        title: 'menu.partners',
        iconType: 'nzIcon',
        iconTheme: 'outline',
        icon: 'usergroup-add',
        submenu: [], 
        role: 'ADMIN'
    },
    {
        path: 'apps/etablissement',
        title: 'menu.etabs',
        iconType: 'nzIcon',
        iconTheme: 'outline',
        icon: 'bank',
        submenu: [], 
        role: 'ADMIN'
    },
      
    {
        path: 'apps/user',
        title: 'menu.users',
        iconType: 'nzIcon',
        iconTheme: 'outline',
        icon: 'user',
        submenu: [],
        role: 'ADMIN'
    },
    {
        path: 'apps/statistiques',
        title: 'menu.stats',
        iconType: 'nzIcon',
        iconTheme: 'outline',
        icon: 'bar-chart',
        submenu: [],
        role: 'ADMIN'
    },
    {
        path: 'apps/email-templates', // -email templates-
        title: 'menu.emailTemplates',
        iconType: 'nzIcon',
        iconTheme: 'outline',
        icon: 'mail',
        submenu: [],
        role: 'ADMIN'
    },
    {
        title: 'menu.logout',
        iconType: 'nzIcon',
        iconTheme: 'outline',
        icon: 'logout',
        submenu: [],
        action: 'logout'  // Vous pouvez utiliser un identifiant d'action pour déclencher la méthode de déconnexion
    }
];
